import {useCallback} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "../@constants";


export default function useAppDefaultFilters(uniqueDashboard, dashboardBlock) {
	const userFilters = useSignal({})
	const isLoadingDefaultFilters = useSignal(true)

	const callUserDefaultFilters = useCallback(() => postSubmit(`${BACKEND_APIS.ADMIN}/user-default/filters`, {
		uniqueDashboard, dashboardBlock 
	}).then((res) => userFilters.value = res)
		.finally(()=> isLoadingDefaultFilters.value = false), [uniqueDashboard])

	return {
		callUserDefaultFilters,
		userFilters: userFilters.value,
		isLoadingDefaultFilters: isLoadingDefaultFilters.value
	}
}